import Request from ".";
import { Routes } from "../constant/api_url";

const getDashboardCounter = async (u_id, u_type, city_id) => {
  try {
    if (u_id != undefined || u_type != undefined || city_id != undefined) {
      const result = await Request.get(
        Routes.GETDASHBOARDCOUNTER + "/" + u_id + "/" + u_type + "/" + city_id
      );
      return result?.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

const userLogout = async (data) => {
  try {
    const result = await Request.get(Routes.USERLOGOUT + "/" + data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLead = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLEAD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeNewLeadList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMENEWLEADLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateprimeleadstatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMELEADSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeLeadList = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETPRIMELEADLIST + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeLeadByLid = async (l_id) => {
  try {
    const result = await Request.get(Routes.GETPRIMELEADBYLID + "/" + l_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeAllocateListById = async (u_id, u_type) => {
  try {
    const result = await Request.get(Routes.GETPRIMEALLOCATELISTBYID + "/" + u_id + "/" + u_type);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const leadTransferTO = async (data) => {
  try {
    const result = await Request.post(Routes.LEADTRANSFERTO, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertFollowUp = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTFOLLOWUP, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeLeadHistory = async (l_id) => {
  try {
    const result = await Request.get(Routes.GETPRIMELEADHISTORY + "/" + l_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const checkDuplicateConfirmedLead = async (data) => {
  try {
    const result = await Request.post(Routes.CHECKDUPLICATECONFIRMEDLEAD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeLeadMemberForm = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMELEADMEMBERFORM, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getNewPrimeLeadDataForExport = async (data) => {
  try {
    const result = await Request.post(Routes.GETNEWPRIMELEADDATAFOREXPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePassword = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPASSWORD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMemberLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERLEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getFollowupLeadList = async (data) => {
  try {
    const result = await Request.post(Routes.GETFOLLOWUPLEADLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLeadRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELEADREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteLeadRejectReason = async (m_f_id) => {
  try {
    const result = await Request.get(Routes.DELETELEADREJECTREASON + "/" + m_f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeLeadRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMELEADREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const GetStaffByPid = async (id, u_type) => {
  try {
    const result = await Request.get(Routes.GETSTAFFBYPID + "/" + id + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertStaff = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTAFF, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateStaffDetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTAFFDETAILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateStaffStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTAFFSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteStaff = async (data) => {
  try {
    const result = await Request.post(Routes.DELETESTAFF, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimeTrainingWebinar = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMETRAININGWEBINAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeTrainingWebinar = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMETRAININGWEBINAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteTrainingWebinar = async (n_id) => {
  try {
    const result = await Request.get(Routes.DELETETRAININGWEBINAR + "/" + n_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllPrimeTrainingWebinar = async (u_type) => {
  try {
    const result = await Request.get(Routes.GETALLPRIMETRAININGWEBINAR + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimeNotification = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMENOTIFICATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeNotification = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMENOTIFICATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletenotification = async (n_id) => {
  try {
    const result = await Request.get(Routes.DELETENOTIFICATION + "/" + n_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getAllPrimeNotification = async (u_type) => {
  try {
    const result = await Request.get(Routes.GETALLPRIMENOTIFICATION + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReadPrimeNotificationData = async (n_id) => {
  try {
    const result = await Request.get(Routes.GETREADPRIMENOTIFICATIONDATA + "/" + n_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllPrimePoll = async (u_type) => {
  try {
    const result = await Request.get(Routes.GETALLPRIMEPOLL + "/" + u_type);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletePoll = async (p_id) => {
  try {
    const result = await Request.get(Routes.DELETEPOLL + "/" + p_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPollPrimeResult = async (p_id) => {
  try {
    const result = await Request.get(Routes.GETPOLLPRIMERESULT + "/" + p_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimePoll = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMEPOLL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimeMember = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMEMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMembershipFlow = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERSHIPFLOW, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updateMembershipFlow = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERSHIPFLOW, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const membershipFlowImageDelete = async (m_f_id) => {
  try {
    const result = await Request.get(Routes.MEMBERSHIPFLOWIMAGEDELETE + "/" + m_f_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMembershipFlowList = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEMEMBERSHIPFLOWLIST, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimeMagazine = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMEMAGAZINE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMagazineList = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEMAGAZINELIST);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const magazineDelete = async (magazine_id) => {
  try {
    const result = await Request.get(Routes.MAGAZINEDELETE + "/" + magazine_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatePrimeMagazine = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMEMAGAZINE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const checkMemberValidation = async (data) => {
  try {
    const result = await Request.post(Routes.CHECKMOBILEVALIDATION, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdatePrimeMember = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMEMEMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetAllPrimeMemberList = async () => {
  try {
    const result = await Request.get(Routes.GETALLPRIMEMEMBERLIST);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetPrimeMemberById = async (id) => {
  try {
    const result = await Request.get(Routes.GETPRIMEMEMBERBYID + "?memberid=" + id);
    return result;
  } catch (error) {
    throw error;
  }
};

const UpdateMemberStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertMemberDeactiveReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTMEMBERDEACTIVEREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMemberDeactiveReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERDEACTIVEREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteMemberDeactiveReason = async (obt_que_id) => {
  try {
    const result = await Request.get(Routes.DELETEMEMBERDEACTIVEREASON + "/" + obt_que_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMemberDeactiveReason = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEMEMBERDEACTIVEREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateSuggestionAnswer = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESUGGESTIONANSWER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteSuggestionAttachmentApi = async (id) => {
  try {
    const result = await Request.delete(Routes.DELETESUGGESTIONATTACHMENT, {
      data: { s_a_id: id }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeSuggestionList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMESUGGESTIONLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const uploadSuggestionChunkApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPLOADSUGGESTIONCHUNK, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertCancelMemberSubject = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCANCELMEMBERSUBJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateCancelMemberSubject = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECANCELMEMBERSUBJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteCancelMemberSubject = async (c_m_s_id) => {
  try {
    const result = await Request.get(Routes.DELETECANCELMEMBERSUBJECT + "/" + c_m_s_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getCancelMemberSubject = async () => {
  try {
    const result = await Request.get(Routes.GETCANCELMEMBERSUBJECT);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getCancelMemberRequestList = async () => {
  try {
    const result = await Request.get(Routes.GETCANCELMEMBERREQUESTLIST);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const approveCancelMemberRequest = async (data) => {
  try {
    const result = await Request.post(Routes.APPROVECANCELMEMBERREQUEST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertLvbsessionPodcast = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTLVBSESSIONPODCAST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateLvbsessionPodcast = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATELVBSESSIONPODCAST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllLvbsessionPodcast = async () => {
  try {
    const result = await Request.get(Routes.GETALLLVBSESSIONPODCAST);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteLvbsessionPodcast = async (l_p_id) => {
  try {
    const result = await Request.get(Routes.DELETELVBSESSIONPODCAST + "/" + l_p_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertPrimeGreeting = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPRIMEGREETING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllPrimeGreeting = async () => {
  try {
    const result = await Request.get(Routes.GETALLPRIMEGREETING);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GreetingDelete = async (g_id) => {
  try {
    const result = await Request.get(Routes.GREETINGDELETE + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const ResendPrimeGreeting = async (g_id) => {
  try {
    const result = await Request.get(Routes.RESENDPRIMEGREETING + "/" + g_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertAskRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTASKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateAskRejectReason = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEASKREJECTREASON, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deleteAskRejectReason = async (a_r_reason_id) => {
  try {
    const result = await Request.get(Routes.DELETEASKREJECTREASON + "/" + a_r_reason_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeAskRejectReason = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEASKREJECTREASON);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeAsksList = async () => {
  try {
    const result = await Request.get(Routes.GETPRIMEASKSLIST);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const askApproveReject = async (data) => {
  try {
    const result = await Request.post(Routes.ASKAPPROVEREJECT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeConfirmMembersList = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMECONFIRMMEMBERSLIST, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateMemberWelcomeKitStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEMEMBERWELCOMEKITSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMemberWelcomeKitHistory = async (m_id) => {
  try {
    const result = await Request.get(Routes.GETPRIMEMEMBERWELCOMEKITHISTORY + "/" + m_id);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMemberWelcomeKitDataExport = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEMEMBERWELCOMEKITDATAEXPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeDashboardCounter = async (u_id, u_type) => {
  try {
    if (u_id != undefined || u_type != undefined) {
      const result = await Request.get(Routes.GETPRIMEDASHBOARDCOUNTER + "/" + u_id + "/" + u_type);
      return result?.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};

const downloadMemberInvocie = async (member_id) => {
  try {
    const result = await Request.get(Routes.DOWNLOADMEMBERINVOCIE + "/" + member_id);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const generateMemberInvoice = async (data) => {
  try {
    const result = await Request.post(Routes.GENERATEMEMBERINVOICE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllCity = async () => {
  try {
    const result = await Request.get(Routes.GETALLCITY, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllState = async () => {
  try {
    const result = await Request.get(Routes.GETALLSTATE, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getAllCountry = async () => {
  try {
    const result = await Request.get(Routes.GETALLCOUNTRY);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPrimeMemberInvoice = async (data) => {
  try {
    const result = await Request.post(Routes.GETPRIMEMEMBERINVOICELIST, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const downloadInvoiceZip = async (data) => {
  try {
    const result = await Request.post(Routes.DOWNLOADINVOICEZIP, data);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getMemberConnectedandBlockList = async (data) => {
  try {
    const result = await Request.post(Routes.GETMEMBERCONNECTEDANDBLOCKLIST, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updateConnectionRequestMailStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECONNECTIONREQUESTMAILSTATUS, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const orangeTickApproveRejectApi = async (data) => {
  try {
    const result = await Request.post(Routes.ORANGETICKAPPROVEREJECT, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertWelcomeKitFollowUp = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTWELCOMEKITFOLLOWUP, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const insertcountry = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCOUNTRY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getApplicationRouteApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETAPPLICATIONROUTE, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertPromoCodeApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPROMOCODE, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const InsertState = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTSTATE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const addUpdateApplicationRouteApi = async (data) => {
  try {
    const result = await Request.post(Routes.ADDUPDATEAPPLICATIONROUTE, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getPromoCodeApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETPROMOCODELIST, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertcity = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
const updateState = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTATE, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePromoCodeApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPROMOCODE, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const updatecity = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITY, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePromoCodeStatusApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPROMOCODESTATUS, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const insertcityambassador = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTCITYAMBASSODAR, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateStateStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESTATESTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateCityStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateCityAmbssadorDetails = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATECITYAMBSSADORDEATILS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const GetActiveMemberByChpt = async (id) => {
  try {
    const result = await Request.get(Routes.GETACTIVEMEMBERBYCHPT + "/" + id);
    return result.data.data;
  } catch (error) {
    throw error;
  }
};

const getPromoCodeWiseMemberListApi = async (data) => {
  try {
    const result = await Request.post(Routes.GETPROMOCODEWISEMEMBERLIST, data);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

const getReferralWithdrawalRequestStatus = async (data) => {
  try {
    const result = await Request.post(Routes.GETREFERRALWITHDRAWALREQUESTSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateReferralWithdrawalRequestStatus = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEREFERRALWITHDRAWALREQUESTSTATUS, data, {
      headers: {
        Accept: "application/json , */*",
        ...(data instanceof FormData
          ? {}
          : { "Content-Type": "application/json" })
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReferralMemberReport = async (data) => {
  try {
    const result = await Request.post(Routes.GETREFERRALMEMBERREPORT, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReferralMemberDetail = async (data) => {
  try {
    const result = await Request.post(Routes.GETREFERRALMEMBERDETAIL, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReferralMemberWalletSetting = async (data) => {
  try {
    const result = await Request.post(Routes.GETREFERRALMEMBERWALLETSETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getReferralWalletSetting = async () => {
  try {
    const result = await Request.get(Routes.GETREFERRALWALLETSETTING);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updateReferralWalletSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEREFERRALWALLETSETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export {
  getDashboardCounter,
  userLogout,
  insertLead,
  getPrimeNewLeadList,
  getPrimeLeadList,
  getPrimeLeadHistory,
  getPrimeAllocateListById,
  updateprimeleadstatus,
  getPrimeLeadByLid,
  insertLeadRejectReason,
  updateLeadRejectReason,
  deleteLeadRejectReason,
  getPrimeLeadRejectReason,
  leadTransferTO,
  insertFollowUp,
  GetStaffByPid,
  insertStaff,
  updateStaffDetails,
  updateStaffStatus,
  deleteStaff,
  insertPrimeTrainingWebinar,
  updatePrimeTrainingWebinar,
  deleteTrainingWebinar,
  getAllPrimeTrainingWebinar,
  updatePrimeNotification,
  insertPrimeNotification,
  deletenotification,
  getReadPrimeNotificationData,
  getAllPrimeNotification,
  getAllPrimePoll,
  deletePoll,
  getPollPrimeResult,
  insertPrimePoll,
  updatePrimeLeadMemberForm,
  checkDuplicateConfirmedLead,
  insertPrimeMember,
  insertMembershipFlow,
  updateMembershipFlow,
  membershipFlowImageDelete,
  getPrimeMembershipFlowList,
  insertPrimeMagazine,
  getPrimeMagazineList,
  magazineDelete,
  updatePrimeMagazine,
  checkMemberValidation,
  UpdatePrimeMember,
  GetAllPrimeMemberList,
  GetPrimeMemberById,
  UpdateMemberStatus,
  insertMemberDeactiveReason,
  updateMemberDeactiveReason,
  deleteMemberDeactiveReason,
  getPrimeMemberDeactiveReason,
  updateSuggestionAnswer,
  getPrimeSuggestionList,
  uploadSuggestionChunkApi,
  deleteSuggestionAttachmentApi,
  insertCancelMemberSubject,
  updateCancelMemberSubject,
  deleteCancelMemberSubject,
  getCancelMemberSubject,
  getCancelMemberRequestList,
  approveCancelMemberRequest,
  insertLvbsessionPodcast,
  updateLvbsessionPodcast,
  getAllLvbsessionPodcast,
  deleteLvbsessionPodcast,
  insertPrimeGreeting,
  getAllPrimeGreeting,
  GreetingDelete,
  ResendPrimeGreeting,
  insertAskRejectReason,
  updateAskRejectReason,
  deleteAskRejectReason,
  getPrimeAskRejectReason,
  getPrimeAsksList,
  askApproveReject,
  getPrimeConfirmMembersList,
  updateMemberWelcomeKitStatus,
  getPrimeMemberWelcomeKitHistory,
  getNewPrimeLeadDataForExport,
  getPrimeMemberWelcomeKitDataExport,
  getPrimeDashboardCounter,
  downloadMemberInvocie,
  generateMemberInvoice,
  updatePassword,
  insertMemberLeadRejectReason,
  getFollowupLeadList,
  getAllCity,
  getAllState,
  getAllCountry,
  getPrimeMemberInvoice,
  downloadInvoiceZip,
  getMemberConnectedandBlockList,
  updateConnectionRequestMailStatus,
  orangeTickApproveRejectApi,
  insertWelcomeKitFollowUp,
  updateState,
  updatecity,
  insertcountry,
  InsertState,
  insertcity,
  UpdateStateStatus,
  UpdateCityStatus,
  GetActiveMemberByChpt,
  insertcityambassador,
  updateCityAmbssadorDetails,
  getApplicationRouteApi,
  addUpdateApplicationRouteApi,
  insertPromoCodeApi,
  getPromoCodeApi,
  updatePromoCodeApi,
  updatePromoCodeStatusApi,
  getPromoCodeWiseMemberListApi,
  getReferralWithdrawalRequestStatus,
  updateReferralWithdrawalRequestStatus,
  getReferralMemberReport,
  getReferralMemberDetail,
  getReferralMemberWalletSetting,
  getReferralWalletSetting,
  updateReferralWalletSetting
};
